import React, { Suspense, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { CloudOutlined } from '@ant-design/icons'
import { WeatherDataProps, VirtualDataProps } from '@/type/publicPropsType'
import MinCard from './MinCard'
import MaxCardInverter from './MaxCardInverter'
import MaxCardHome from './MaxCardHome'
import LoadedDevices from './LoadedDevices'
// const FlowLine = lazy(() => import("./FlowLine"));
// import NumberScroller from "../components/NumberScroller"

const Left: React.FC<WeatherDataProps & { powerData: VirtualDataProps[]; deviceState: number | undefined }> = ({
  weather,
  temp,
  powerData,
  deviceState,
}) => {
  //定义方向 0正向 1反向 -1无
  const [solarPower, setSolarPower] = useState<VirtualDataProps>()
  const [batteryPower, setBatteryPower] = useState<VirtualDataProps>()
  const [batterySOC, setBatterySOC] = useState<VirtualDataProps>()
  const [genPower, setGenPower] = useState<VirtualDataProps>()
  const [loadPower, setLoadPower] = useState<VirtualDataProps>()
  const [gridPower, setGridPower] = useState<VirtualDataProps>()
  const [dailyPV, setDailyPV] = useState<VirtualDataProps>()
  const [dailyCharge, setDailyCharge] = useState<VirtualDataProps>()
  const [dailyConsumption, setDailyConsumption] = useState<VirtualDataProps>()
  const [dailySales, setDailySales] = useState<VirtualDataProps>()
  const [loadedDevices, setLoadedDevices] = useState<VirtualDataProps[]>([])

  useEffect(() => {
    setSolarPower(powerData.find((item) => item.label_name === 'PV'))
    setBatteryPower(powerData.find((item) => item.label_name === 'Battery' && item.property_code === 'P'))
    setBatterySOC(powerData.find((item) => item.label_name === 'Battery' && item.property_code === 'SOC'))
    setGenPower(powerData.find((item) => item.label_name === 'Gen'))
    setLoadPower(powerData.find((item) => item.label_name === 'Load' && item.property_code === 'P'))
    setGridPower(powerData.find((item) => item.label_name === 'Grid'))
    setDailyPV(powerData.find((item) => item.label_name === 'DailyPV'))
    setDailyCharge(powerData.find((item) => item.label_name === 'DailyCharge'))
    setDailyConsumption(powerData.find((item) => item.label_name === 'DailyConsumption'))
    setDailySales(powerData.find((item) => item.label_name === 'DailySales'))
    const evChargerPower = powerData.find((item) => item.label_name === 'Load' && item.property_code === 'EV-P') || {
      value: 0,
      unit: 'w',
      label_name: 'Load',
    }
    const heatPumpPower = powerData.find((item) => item.label_name === 'Load' && item.property_code === 'HP-P') || {
      value: 0,
      unit: 'w',
      label_name: 'Load',
    }
    const lightingPower = powerData.find((item) => item.label_name === 'Load' && item.property_code === 'IL-P') || {
      value: 0,
      unit: 'w',
      label_name: 'Load',
    }
    const poolFilterPower = powerData.find((item) => item.label_name === 'Load' && item.property_code === 'PF-P') || {
      value: 0,
      unit: 'w',
      label_name: 'Load',
    }
    const waterHeaterPower = powerData.find((item) => item.label_name === 'Load' && item.property_code === 'WH-P') || {
      value: 0,
      unit: 'w',
      label_name: 'Load',
    }
    const newLoadedDevices = [
      { ...evChargerPower, label: 'evCharger' },
      { ...waterHeaterPower, label: 'waterHeater' },
      { ...heatPumpPower, label: 'heatPump' },
      { ...poolFilterPower, label: 'poolFilter' },
      { ...lightingPower, label: 'lighting' },
    ]
    setLoadedDevices(newLoadedDevices)
  }, [powerData])

  return (
    <div className='FlowModel'>
      <div className='FlowModel-top'>
        <CloudOutlined />
        {weather} {temp}℃
      </div>
      <div className='FlowModel-content'>
        <div className='flowModel-flex flowModel-one'>
          <Link to={deviceState !== undefined ? `../inverter/${deviceState}/solar` : ''} id='Flow-Solar'>
            <MinCard
              name='solar'
              value={Math.abs(solarPower?.value || 0).toFixed(2)}
              unit={solarPower?.unit || ''}
              statusText={(solarPower?.value || 0) > 0 ? 'running' : 'standby'}
            />
          </Link>
          <div className={`flow-Solar-inverter-line flow-line direction${solarPower?.value || 0 > 0 ? 0 : -1}`}>
            <div className='flow-yuan'></div>
          </div>
          <MaxCardInverter
            dailyPV={(dailyPV?.value || 0).toFixed(2)}
            dailyCharge={(dailyCharge?.value || 0).toFixed(2)}
            dailyConsumption={(dailyConsumption?.value || 0).toFixed(2)}
            dailySales={(dailySales?.value || 0).toFixed(2)}
          />
          <div className='flow-line2'></div>
          <div className={`flow-inverter-Gen-line flow-line direction${genPower?.value || 0 > 0 ? 0 : -1}`}>
            <div className='flow-yuan'></div>
          </div>

          <Link to={deviceState !== undefined ? `../inverter/${deviceState}/gen` : ''} id='Flow-Gen'>
            <MinCard
              name='gen'
              value={Math.abs(genPower?.value || 0).toFixed(2)}
              unit={genPower?.unit || ''}
              statusText={(genPower?.value || 0) > 0 ? 'running' : 'standby'}
            />
          </Link>
        </div>
        <div className='flow-lines2'>
          <div
            className={`flow-inverter-Battery-line flow-line direction${
              (batteryPower?.value || 0) > 0 ? 1 : (batteryPower?.value || 0) < 0 ? 0 : -1
            }`}>
            <div className='flow-yuan'></div>
          </div>
          <div className={`flow-inverter-Load-line flow-line direction${loadPower?.value || 0 > 0 ? 0 : -1}`}>
            <div className='flow-yuan'></div>
          </div>
          <div
            className={`flow-inverter-Grid-line flow-line direction${
              (gridPower?.value || 0) > 0 ? 1 : (gridPower?.value || 0) < 0 ? 0 : -1
            }`}>
            {/* <Tooltip title="error Info">
              <img className="cha" src="/assets/image/cha.svg" />
            </Tooltip> */}
            <div className='flow-yuan'></div>
          </div>
        </div>
        <div className='flowModel-flex  flowModel-two'>
          <Link to={deviceState !== undefined ? `../inverter/${deviceState}/battery` : ''} id='Flow-Battery'>
            <MinCard
              name={'battery'}
              value={Math.abs(batteryPower?.value || 0).toFixed(2)}
              unit={batteryPower?.unit || ''}
              statusText={
                (batteryPower?.value || 0) > 0 ? 'discharging' : (batteryPower?.value || 0) < 0 ? 'charging' : 'standby'
              }
              batterySOC={batterySOC?.value || 0}
            />
          </Link>
          <Link to={deviceState !== undefined ? `../inverter/${deviceState}/load` : ''} id='Flow-Load'>
            <MaxCardHome
              loadPower={loadPower?.value || 0}
              unit={loadPower?.unit || ''}
              statusText={(loadPower?.value || 0) > 0 ? 'loaded' : 'noLoad'}
            />
          </Link>
          <Link to={deviceState !== undefined ? `../inverter/${deviceState}/grid` : ''}>
            <MinCard
              name='grid'
              value={Math.abs(gridPower?.value || 0).toFixed(2)}
              unit={gridPower?.unit || ''}
              statusText={(gridPower?.value || 0) > 0 ? 'buying' : (gridPower?.value || 0) < 0 ? 'selling' : 'standby'}
            />
          </Link>
        </div>
        <div className='flow-lines3'>
          <div
            className={`flow-Load-cp1-line flow-line direction${
              loadedDevices.some((item) => Number(item.value) > 0) ? 0 : 1
            }`}>
            <div className='flow-yuan'></div>
          </div>
        </div>
        <div className='flowModel-flex-center flowModel-two'>
          <LoadedDevices loadedDevicesPower={loadedDevices} />
        </div>
        <Suspense fallback={<div>Loading Flow Line...</div>}>{/* <FlowLine /> */}</Suspense>
      </div>
    </div>
  )
}

export default Left
